/**
 * 获取用户数据
 */
export const user = state => {
  return state.user
}
/**
 * 获取配置数据
 */
export const options = state => {
  return state.options
}

/**
 * 获取用户登录状态
 */
export const isLogin = state => {
  return !!Object.keys(state.user || {}).length && !!state.user.nick
}

/**
 * 获取在app里是否获得到数据的状态
 */
export const isFetchAppUserData = state => {
  return state.isFetchAppUserData
}

/**
 * 获取是否已获取配置数据的状态
 */
export const hasGetOptions = state => {
  return state.hasGetOptions
}

/**
 * 获取直播类型
 */
export const liveType = state => {
  return state.liveType
}

/**
 * 设置直播相关信息
 */
export const liveInfo = state => {
  return state.liveInfo
}

/**
 * 设置直播链接
 */
export const liveUrl = state => {
  return state.liveUrl
}

/**
 * 直播状态
 */
export const isLive = state => {
  return state.isLive
}

/**
 * 所有频道的直播状态
 */
export const channelLiveState = state => {
  return state.channelLiveState
}

/**
 * 设置chat的加载状态
 */
export const chatReadyState = state => {
  return state.chatReadyState
}

/**
 * 判断是否是移动端
 */
export const isMobile = state => {
  return state.isMobile
}

/**
 * 服务器时间
 */
export const serverTime = state => {
  return state.serverTime
}

/**
 * 视频海报链接
 */
export const posterUrl = state => {
  return state.posterUrl
}

/**
 * 主持人
 */
export const emcee = state => {
  return state.emcee
}

/**
 * 视频id
 */
export const videoID = state => {
  return state.videoID
}

/**
 * 同传的视频id，无直播时优先获取到的是预告id
 */
export const tradingVideoID = state => {
  return state.tradingVideoID
}

/**
 * 预告的时间
 */
export const prevueTime = state => {
  return state.prevueTime
}

export const fmLivePlayState = state => {
  return state.fmLivePlayState
}

export const fmReplayState = state => {
  return state.fmReplayState
}

export const fmVideo = state => {
  return state.fmVideo
}

export const fmEmmecNotice = state => {
  return state.fmEmmecNotice
}

export const isShowFMSign = state => {
  return state.isShowFMSign
}

export const weekTalkDatas = state => {
  return state.weekTalkDatas
}

export const isMobileView = state => state.windowWidth < 768



// WEBPACK FOOTER //
// ./src/store/getters.js